import { useState, useEffect, useReducer } from 'react';
import { loadingStateManager } from 'app/stores/loadingStore';

/**
 * Hook to access the global route loading state
 * @returns The current loading state (true when a route is loading)
 */
export const useRouteLoading = (): boolean => {
  // Initialize with current state
  const [isLoading, setIsLoading] = useState(loadingStateManager.getIsLoading());
  
  // Force update function to ensure component re-renders when loading state changes
  const [, forceUpdate] = useReducer(x => x + 1, 0);
  
  useEffect(() => {
    // console.log('useRouteLoading hook mounted, current state:', loadingStateManager.getIsLoading());
    
    // Subscribe to changes
    const unsubscribe = loadingStateManager.subscribe((newState) => {
      // console.log('Loading state changed to:', newState);
      setIsLoading(newState);
      forceUpdate(); // Force component to update
    });
    
    // Update state if it changed between render and effect
    if (isLoading !== loadingStateManager.getIsLoading()) {
      // console.log('State was different in effect, updating');
      setIsLoading(loadingStateManager.getIsLoading());
    }
    
    // Cleanup subscription on unmount
    return unsubscribe;
  }, []);
  
  return isLoading;
}; 